import { HiveListParams, HiveListResult } from "../types";
import useRequest, { Fetch, RequestResult } from "./useRequest";

export default function useHiveList(
  params?: HiveListParams,
): [RequestResult<HiveListResult>, Fetch] {
  return useRequest<HiveListResult, any>("/hive/list/", { expanded: 1, ...params });
}
